import { EAttachmentType } from '@constants';
import { IAttachment, IFile } from '@sdk/contracts';
import { Flex } from 'antd';
import { useTranslation } from 'react-i18next';

import { FileAttachment } from './FileAttachment';
import { LinkAttachment } from './LinkAttachment';

type Props = {
  value?: IAttachment[];
  onChange?: (value: IAttachment[]) => void;
};

export const Attachments: React.FC<Props> = ({ value = [], onChange }) => {
  const { t } = useTranslation('CourseTranslations');

  const data = value.reduce((acc, curr) => {
    if (curr.type === EAttachmentType.FILE) acc.files.push(curr.file);
    if (curr.type === EAttachmentType.LINK) acc.links.push(curr.link);
    return acc;
  }, Object.create({ files: [], links: [] })) as { files: IFile[]; links: string[] };

  const { files, links } = data;

  const handleAdd = (newValue: IAttachment) => onChange?.([...value, newValue]);

  const handleFileRemove = (updatedFiles: IAttachment[]) => {
    const filteredAttachments = value.filter(item => item.type === EAttachmentType.LINK);
    onChange?.([...filteredAttachments, ...updatedFiles]);
  };

  const handleLinkRemove = (link: string) => {
    const updatedValue = value.reduce((acc, curr) => {
      if (curr.type === EAttachmentType.LINK && curr.link === link) {
        return acc;
      }
      return [...acc, curr];
    }, [] as IAttachment[]);
    onChange?.(updatedValue);
  };

  return (
    <Flex vertical gap={12}>
      <FileAttachment
        label={t('ATTACH_ADITIONAL_MATERIAL')}
        files={files}
        onAdd={handleAdd}
        onRemove={handleFileRemove}
      />
      <LinkAttachment links={links} onAdd={handleAdd} onRemove={handleLinkRemove} />
    </Flex>
  );
};
